import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Jackpot } from '../Jackpot';
import { StringUtilService } from '../../../../../../shared/src/services/util/string-util.service';
import { JackpotSourcesEnum } from '../../../../../../shared/src/enums/jackpot-sources.enum';

const JackpotWrapper = (Component, thumbnailSize, {
    jackpotSource = JackpotSourcesEnum.PARI_PLAY,
    jackpotId,
}) => {
    const [jackpotAmount, setJackpotAmount] = useState(0);
    const { jackpots, ngProgressiveJackpots } = useSelector((state) => state.jackpots);
    const { intJackpotsBasic, intJackpotsPremium, jackpotTickerNg } =  useSelector((state) => state.app.config);
    const { balance } = useSelector((state) => state.player);
    const decodeCurrency = StringUtilService.decodeHtmlEntity(balance?.CurrencySign);

    useEffect(() => {
        if (jackpotSource === JackpotSourcesEnum.PARI_PLAY && jackpotId) {
            const jackpotValue = jackpots[jackpotId]?.amount[balance?.Currency];
            setJackpotAmount(jackpotValue);
        }
    }, [jackpots, jackpotId]);

    useEffect(() => {
        if (jackpotSource === JackpotSourcesEnum.NG_PJP && jackpotId) {
            const currencyCode = balance?.Currency;
            const jackpotAmount = ngProgressiveJackpots
                ?.amountsById
                ?.[currencyCode]
                ?.[jackpotId];
            setJackpotAmount(jackpotAmount);
        }
    }, [ngProgressiveJackpots, jackpotId]);

    const ppJackpotsEnabled = jackpotSource === JackpotSourcesEnum.PARI_PLAY
        && (intJackpotsBasic || intJackpotsPremium);
    const ngProgressiveJackpotsEnabled = jackpotSource === JackpotSourcesEnum.NG_PJP
        && jackpotTickerNg;

    return function WrapperComponent(props) {
        return (
            <>
                <Component {...props} />
                {(ppJackpotsEnabled || ngProgressiveJackpotsEnabled) && jackpotAmount !== 0 &&
                    <Jackpot
                        amount={jackpotAmount}
                        currency={decodeCurrency}
                        thumbnailSize={thumbnailSize}
                        jackpotSource={jackpotSource}
                        jackpotId={jackpotId}
                    />
                }
            </>
        );
    };
};

export default JackpotWrapper;
